module.exports = __webpack_public_path__ + "static/start-cc31dfd8cfe35148b4f1a754fd27c61b.svg";